export enum DOCUMENT_PRINT_TYPE {
  Original = 1,
  Duplicate = 2,
}
